import React, { Component } from 'react';
import style from './style/result_text_block.scss';

export default class ResultTextBlock extends Component {
    render() {
        const { evaluation, classes, children } = this.props;

        return (
            <div className={classes.root} >
                <div className={ `${style.resultTextBlock} ${classes.resultIndicator}` }>
                    <figure className={style.indicatorText}>{evaluation}</figure>
                </div>
                {children}
            </div>
        );
    }
}
